import { render } from "./ExpertCounseling.vue?vue&type=template&id=179a462e"
import script from "./ExpertCounseling.vue?vue&type=script&lang=js"
export * from "./ExpertCounseling.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Dev Workspace/IBC-PROJECT-DEV/ibc-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QImg});
